// extracted by mini-css-extract-plugin
export var blockBtn = "registration-module--block-btn--66e1e";
export var mainBtn = "registration-module--main-btn--13a7d";
export var mainTitle = "registration-module--main-title--67447";
export var registration = "registration-module--registration--b2847";
export var registration__button = "registration-module--registration__button--c1353";
export var registration__course = "registration-module--registration__course--795e6";
export var registration__coursePrice = "registration-module--registration__course-price--31d14";
export var registration__gift = "registration-module--registration__gift--f6a9d";
export var registration__icon = "registration-module--registration__icon--fd431";
export var registration__modal = "registration-module--registration__modal--f2fea";
export var registration__recommendation = "registration-module--registration__recommendation--401ed";
export var registration__subtitle = "registration-module--registration__subtitle--35174";
export var registration__subtitleOrange = "registration-module--registration__subtitle--orange--b91b4";
export var registration__text = "registration-module--registration__text--d0ca1";
export var registration__textLineThrough = "registration-module--registration__text--line-through--7942a";
export var registration__title = "registration-module--registration__title--3b2b1";
export var registration__wrapper = "registration-module--registration__wrapper--641c0";
export var title = "registration-module--title--fcda8";